import Vue from 'vue';
import VueI18n from 'vue-i18n';

const messages = {
  en: {
    message: {
      /*
      * common
      */
      inactiveSession: 'Your session is now inactive, and you will be logged out automatically in {logoutCountdown} seconds.',
      ok: 'Ok',
      yes: 'Yes',
      no: 'No',
      cancel: 'Cancel',
      save: 'Save',
      exit: 'Exit',
      submit: 'Submit',
      signIn: 'Sign In',
      register: 'Register',
      forgotUsername: 'Forgot Username?',
      forgotPassword: 'Forgot Password?',
      returnToLogin: 'Return to Login',
      username: 'Username',
      password: 'Password',
      dateOfBirth: 'Date of Birth',
      ssn: 'Social Security Number',
      email: 'Email',
      phone: 'Phone',
      emailAddress: 'Email Address',
      phoneNumber: 'Phone Number',
      desiredUsername: 'Desired Username',
      currentPassword: 'Current Password',
      newPassword: 'New Password',
      confirmPassword: 'Confirm Password',
      confirmNewPassword: 'Confirm New Password',
      savePassword: 'Save Password',
      currentValue: 'Current Value',
      howToSendUsername:'How would you like us to send your username?',
      howToSendResetCode:'How would you like us to send your reset code?',
      getUsername: 'Get Username',
      sendPasswordResetInstructions: 'Send Password Reset Instructions',
      processingRegistration: 'Processing Registration',
      /*
      * consumer-grav
      */
      next: 'Next',
      back: 'Back',
      remove: 'Remove',
      edit: 'Edit',
      saveEdit: 'Save Edit',
      identification: 'Identification',
      passportPicture: 'Passport (Picture Page)',
      driverLicenseFront: 'Driver\'s License Front',
      driverLicenseBack: 'Driver\'s License Back',
      idFront: 'ID Front',
      idBack: 'ID Back',
      readingYourId: 'Reading your ID, this may take up to 2 minutes.',
      contactInfo: 'Contact Info',
      otherInfo: 'Other Info',
      personalReference: 'Personal Reference',
      challengeQuestionsHeader: 'Challenge Questions',
      identityVerification: 'Identity Verification',
      primaryApplicantIdentityVerification: 'Primary Applicant Identity Verification',
      primaryApplicantIdentification: 'Primary Applicant Identification',
      primaryApplicantContactInfo: 'Primary Applicant Contact Info',
      primaryApplicantOtherInfo: 'Primary Applicant Other Info',
      primaryApplicantPersonalReference: 'Primary Applicant Personal Reference',
      primaryApplicantChallengeQuestionsHeader: 'Primary Applicant Challenge Questions',
      review: 'Review',
      accounts: 'Accounts',
      funding: 'Funding',
      jointApplicantIdentification: 'Joint Applicant Identification',
      jointApplicantContactInfo: 'Joint Applicant Contact Info',
      jointApplicantOtherInfo: 'Joint Applicant Other Info',
      jointApplicantPersonalReference: 'Joint Applicant Personal Reference',
      jointApplicantChallengeQuestionsHeader: 'Joint Applicant Challenge Questions',
      missingRequiredFieldsMsg: 'You must fill out the required fields.',
      missingRequiredIdImageMsg: 'You must upload the required images of your ID.',
      missingRequiredAgeMsg: 'You must be 18 or older to apply for membership online.',
      thankYouForYourApplication: 'Thank You For Your Membership Application',
      emailAgreement: "Email the Agreement",
      printAgreement: "Print the Agreement",
      acceptDisclosure: 'Accept Disclosure',
      saveAndContinue: 'Save & Continue'
    }
  },
  es: {
    message: {
      /*
      * common
      */
      inactiveSession: 'Your session is now inactive, and you will be logged out automatically in {logoutCountdown} seconds.',
      ok: 'Okay',
      yes: 'Si',
      no: 'No',
      cancel: 'Cancelar',
      save: 'Guardar',
      exit: 'Salida',
      submit: 'Guardar',
      signIn: 'El Acceso',
      register: 'Registrar',
      forgotUsername: '¿Olvidaste tu nombre de usuario?',
      forgotPassword: '¿Olvidaste tu contraseña?',
      returnToLogin:'Volver al inicio de sesión',
      username: 'Nombre de Usuario',
      password: 'Contraseña',
      dateOfBirth: 'Fecha de Nacimiento',
      ssn: 'Número de Seguro Social',
      email: 'Email',
      phone: 'Número de celular',
      emailAddress: 'Dirección de correo electrónico',
      phoneNumber: 'Número de teléfono',
      desiredUsername: 'Nombre de usuario deseado',
      currentPassword: 'Contraseña actual',
      newPassword: 'Contraseña nueva',
      confirmPassword: 'Confirmar contraseña',
      confirmNewPassword: 'Confirmar nueva contraseña',
      savePassword: 'Guardar contraseña',
      currentValue: 'Current Value',
      howToSendUsername:'How would you like us to send your username?',
      howToSendResetCode:'¿Cómo le gustaría que le enviemos su código de restablecimiento?',
      getUsername: 'Get Username',
      sendPasswordResetInstructions: 'Send Password Reset Instructions',
      processingRegistration: 'Processing Registration',
      /*
      * consumer-grav
      */
    }
  }
}

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: 'en',
  messages,
});

export default i18n;